import React from 'react';
import ReactDOM from 'react-dom';
import jQuery from 'jquery';
import 'jquery.easing';
import 'bootstrap';
import 'font-awesome-webpack';

import 'bootstrap/dist/css/bootstrap.min.css';

import './grayscale.css';
import './index.css';

import App from './components/App';
// import registerServiceWorker from './registerServiceWorker';

global.jQuery = jQuery;

ReactDOM.render(<App />, document.getElementById('root'));
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js